// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"92":"3080b7ca","243":"85e62a48","273":"3080b7ca","333":"3080b7ca","533":"701b9aea","548":"920a1922"}[chunkId] + ".chunk.css";
};